import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared/core2Config';
import { InventoryPdgContainerModel, PdgFilterLinksReqContainerModel, InventoryPdgCategoryGroupColumnNamesCombinationDto,InventoryPdgUniqueCategoryGroupContainer } from '../../../../../models/aggregates/inventory-pdg';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { ApiVisa, BasicApiResponseModel } from '../shared';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class InventoryPdgUniqueCombinationService extends BaseApiPublicLoginTemplateService<InventoryPdgContainerModel,InventoryPdgContainerModel,InventoryPdgContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'pdg-unique-combination/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'pdg-unique-combination/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

  postPdg(container: PdgFilterLinksReqContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<InventoryPdgContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<InventoryPdgContainerModel>>(
      url,
      container,
      this.getHttpHeader(visa)
    );
  }

  putPdg(container: PdgFilterLinksReqContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<InventoryPdgContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<BasicApiResponseModel<InventoryPdgContainerModel>>(
      url,
      container,
      this.getHttpHeader(visa)
    );
  }

  getUniqueCategoryCombinations(
    dtoObject: InventoryPdgCategoryGroupColumnNamesCombinationDto[], 
    apiVisa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
  
    // Construct the URL using the apiVisa.api_domain_url and endpoint_path
    const apiUrl = apiVisa.api_domain_url 
      ? `${apiVisa.api_domain_url}${this.endpoint_path}/get-unique-category-group` 
      : `${this.apiUrl}/get-unique-category-group`;
  
    // Make the HTTP POST request and return the observable
    return this.httpClient.post<BasicApiResponseModel<any>>(
      apiUrl,
      dtoObject,
      this.getHttpHeader(apiVisa)
    );
  }

  getTargetCategoryValues(
    targetColumn: string,
    filters: InventoryPdgCategoryGroupColumnNamesCombinationDto[],
    apiVisa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {

    // Construct the URL using the apiVisa.api_domain_url and endpoint_path
    const apiUrl = apiVisa.api_domain_url 
      ? `${apiVisa.api_domain_url}${this.endpoint_path}/get-target-category-values`
      : `${this.apiUrl}/get-target-category-values`;

    // Build request body
    const requestBody = {
      targetColumn: targetColumn,
      filters: filters
    };

    // Make the HTTP POST request and return the observable
    return this.httpClient.post<BasicApiResponseModel<any>>(
      apiUrl,
      requestBody,
      this.getHttpHeader(apiVisa)
    );
  }

}